'use client';

import { type ReactElement, useContext, useState, createContext } from 'react';

const LoadingContext = createContext<{
  readonly loaded: boolean;
  readonly setLoaded: (loaded: boolean) => void;
}>({ loaded: false, setLoaded: () => {} });

export default function LoadingContextProvider({
  children,
}: {
  readonly children: ReactElement;
}): ReactElement {
  const [loaded, setLoaded] = useState(false);

  return (
    <LoadingContext.Provider value={{ loaded, setLoaded }}>{children}</LoadingContext.Provider>
  );
}

export function useLoading() {
  return useContext(LoadingContext);
}
